<template>
  <article>
    <section class="xbed-sub-title">
      <span>途家渠道门店详情</span>
    </section>

    <section class="xbed-breadcrumb">
      <Breadcrumb>
        <BreadcrumbItem>OTA</BreadcrumbItem>
        <BreadcrumbItem>途家渠道列表</BreadcrumbItem>
        <BreadcrumbItem>途家渠道门店详情</BreadcrumbItem>
      </Breadcrumb>
    </section>

    <Tabs class="tabs" @on-click="toggleTab" style="margin-top: 20px">
      <TabPane label="渠道门店信息" name="channelHotelInfo">
        <channel-hotel-info :data="channelHotelInfo"></channel-hotel-info>
      </TabPane>
      <TabPane label="xbed门店信息" name="xbedHotelInfo">
        <xbed-hotel-info :data="xbedHotelInfo"></xbed-hotel-info>
      </TabPane>
      <TabPane label="门店房型列表" name="roomTypeList">
        <room-type-list ref="roomTypeList" :query="getRoomTypeListApi" @onConfirm="preAddRoomType"></room-type-list>
      </TabPane>
      <TabPane label="渠道活动列表" name="activityList">
        <channel-activity-list ref="activityList" :query="getActivityListApi"></channel-activity-list>
      </TabPane>
      <TabPane label="取消规则" name="cancelRules">
        <cancel-rules></cancel-rules>
      </TabPane>
    </Tabs>
  </article>
</template>

<script>
import Utils from "@/utils";
import API from "@/api";

import channelHotelInfo from "./channel-hotel-info"
import xbedHotelInfo from "./xbed-hotel-info"
import roomTypeList from "./room-type-list"
import channelActivityList from "./channel-activity-list"
import cancelRules from "./cancel-rules"

export default {
  async created() {
    this.token = Utils.findFromLocalStorage("vue-token");
    this.username = Utils.findFromLocalStorage("vue-username");
    this.env = Utils.findFromLocalStorage("env", "dev");
    this.hotelId = Utils.getUrlParameterByName("hotelId");
  },
  async mounted() {
    this.$Notice.config({
      top: 200
    });
    this.toggleTab(this.currTabName);

    this.queryChannelHotelInfo();
  },
  data() {
    return {
      channelId: 4,
      currTabName: "channelHotelInfo",
      channelHotelInfo:{},  // 基本信息
      xbedHotelInfo: {},  // 门店信息
    };
  },
  methods: {
    toggleTab(tabName) {
      this.currTabName = tabName;
      this.queryHotelData();
    },
    queryHotelData() {
      if (this.currTabName == 'roomTypeList') {
        this.queryRoomTypeList()
      }
    },
    // 查询基本信息
    async queryChannelHotelInfo(){
      let resp = (await this.findChannelHotelInfo(
        this.token,
        this.env
      )).data;
      if (resp.retCode) {
        this.$Notice.error({
          title: resp.msg
        });
      }

      this.channelHotelInfo = Object.assign({}, {
        channelHotelId: resp.channelHotelId,
        channelHotelName: resp.channelHotelName,
        contactPhone: resp.contactPhone || '4006099222',
        email: resp.email || 'service@xbed.com.cn',
        province: resp.province,
        city: resp.city,
        cityId: resp.cityId,
        district: resp.district,
        districtId: resp.districtId,
        address: resp.address,
        longitude: resp.longitude,
        latitude: resp.latitude,
        remark: resp.remark,
        matchStatus: resp.matchStatus,
        status: resp.status
      });

      this.xbedHotelInfo = Object.assign({}, {
        xbedHotelId: resp.xbedHotelId,
        xbedHotelName: resp.xbedHotelName,
        contactName: resp.contactName,
        contactPhone: resp.contactPhone,
        province: resp.province,
        city: resp.city,
        district: resp.district,
        remark: resp.remark
      });
    },
    findChannelHotelInfo(token, env) {
      return API.omsAPI[env].ota.findHotel(
        this.hotelId,
        token
      );
    },
    // 查询门店房型列表
    queryRoomTypeList() {
      this.$refs.roomTypeList.queryList();
    },
    // 门店房型列表获取接口方法
    getRoomTypeListApi() {
      return API.omsAPI[this.env].ota.queryFeizhuRoomTypeList;
    },
    // 新增房型
    preAddRoomType(payload) {
      const { name, bufferNum } = payload;

      console.info(name, bufferNum)
    },
    // 查询渠道活动列表
    queryActivityList() {
      this.$refs.activityList.queryList();
    },
    // 渠道活动列表
    getActivityListApi() {
      return API.omsAPI[this.env].ota.queryFeizhuRoomTypeList;
    }

  },
  components: {
    'channel-hotel-info': channelHotelInfo,
    'xbed-hotel-info': xbedHotelInfo,
    'room-type-list': roomTypeList,
    'channel-activity-list': channelActivityList,
    'cancel-rules': cancelRules
  }
};
</script>

<style lang="scss" scoped>
.add-wrapper {
  margin-top: 20px;
}

.tabs {
  margin-top: 20px;
}

.table-wrapper {
  margin-top: 20px;
}

.text-align-right {
  text-align: right;
}

</style>



// WEBPACK FOOTER //
// src/pages/ota/tujia/hotel-detail/index.vue